// Chakra imports
import {Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue,} from "@chakra-ui/react";
// Custom components
import React, {useCallback, useMemo, useRef, useState} from "react";
import axios from 'axios'
import {useAuthHeader} from 'react-auth-kit'
import {getCoreRowModel, getFilteredRowModel, getSortedRowModel, useReactTable,} from '@tanstack/react-table'
import {useInfiniteQuery} from '@tanstack/react-query'
import "./modal.css"
import TableAuditLogRow from "../../TableAuditLogRow";
import {useNavigate} from "react-router-dom";
import {FaBackspace} from "react-icons/fa";

const fetchSize = 100

const AuditLogTable = ({ title, columns, id }) => {
    const textColor = useColorModeValue("gray.700", "white");

    const [sorting, setSorting] = useState([])
    const [terminal, setTerminal] = useState('')
    const [totalDBRowCount, setTotalDBRowCount] = useState(null)
    const token = useAuthHeader();
    const navigate = useNavigate();

    const { data, fetchNextPage, isFetching, isLoading } =
        useInfiniteQuery(
            ["audit_log", sorting],
            async ({ pageParam = 0 }) => {
                const res = await axios.get(`/api/v1/audit_log?tx_id=${id}&limit=${fetchSize}&page=${pageParam+1}&search_meta=true`, { headers: {Authorization: token() } })
                setTotalDBRowCount(res.data.total)
                setTerminal("Провайдер: " +  res.data.data[0]['meta']['provider'] +"  Терминал: " + res.data.data[0]['meta']['terminal'])
                return await res.data.data

            }, {
                getNextPageParam: (_lastGroup, groups) => groups.length,
            }
        )

    const flatData = useMemo(
        () => data?.pages?.flatMap(page => page) ?? [],
        [data])

    const totalFetched = flatData.length

    const fetchMoreOnBottomReached = useCallback(
        (containerRefElement) => {
            if (containerRefElement) {
                const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
                if (
                    scrollHeight - scrollTop - clientHeight < 300 &&
                    !isFetching &&
                    totalFetched < totalDBRowCount
                ) {
                    fetchNextPage()
                }
            }
        },
        [fetchNextPage, isFetching, totalFetched, totalDBRowCount]
    )

    const table = useReactTable({
        data: flatData,
        columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getFilteredRowModel: getFilteredRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        enableGlobalFilter: true
    })
    const { rows } = table.getRowModel()
    return (
        <>
            <Box p='6px 0px 22px 0px'
            >
                <Table variant='striped' color={textColor}>
                    <Thead>
                        <tr>
                            <th align="left">
                                <Text fontSize='xl' color={textColor} fontWeight='bold'>
                                    {title}
                                </Text>
                                <Text fontSize='sm' color={textColor}>
                                    {terminal}
                                </Text>
                            </th>
                            <th align={"right"} width={"150px"}>
                                <Flex
                                    align='center'
                                    w={{ lg: "135px" }}
                                    borderRadius='15px'
                                    justifyContent='center'
                                    onClick={() => {navigate(`/admin_area/transactions/${id}`, {replace: true})}}
                                    py='10px'
                                    cursor='pointer'>
                                    {<FaBackspace w='100%' h='100%' />}
                                    <Text
                                        fontSize='xs'
                                        color={textColor}
                                        fontWeight='bold'
                                        ms='6px'>
                                        {'back'}
                                    </Text>
                                </Flex>
                            </th>
                        </tr>
                    </Thead>
                </Table>
            </Box>

            <Box overflowX="auto"
                 maxHeight={window.innerHeight - 280}
                 onScroll={e => fetchMoreOnBottomReached(e.target)}
            >
                <Table variant='striped' color={textColor}>
                    <Thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <Tr key={headerGroup.id}  my='.8rem' pl='0px' color='gray.400'>
                                {headerGroup.headers.map((header, idx) => {
                                    return (
                                        <Th
                                            key={header.id}
                                            color='gray.400'
                                            ps={idx === 0 ? "0px" : null}
                                            pl={idx === 0 ? "25px" : null}
                                        >
                                            <div
                                                className={
                                                    header.column.getCanSort()
                                                        ? 'cursor-pointer select-none'
                                                        : undefined
                                                }
                                                onClick={header.column.getToggleSortingHandler()}
                                            >
                                                {header.column.columnDef.header}
                                                {{asc: ' 🔼', desc: ' 🔽',}[header.column.getIsSorted()] ?? null}
                                            </div>
                                        </Th>
                                    )
                                })}
                            </Tr>
                        ))}
                    </Thead>
                    <Tbody>
                        {isLoading ? (
                            <Tr>
                                <Td colSpan={table.getHeaderGroups()[0].headers.length}>Загрузка...</Td>
                            </Tr>
                        ) : rows.map(row => {
                            return (
                                <TableAuditLogRow key={row.id} row={row} />
                            )
                        })}
                    </Tbody>
                </Table>

            </Box>
            <Text>
                {flatData.length > 0
                    ? `Fetched ${flatData.length} of ${totalDBRowCount} Rows`
                    : "Ничего не найдено"
                }
            </Text>
        </>
    );
};

export default AuditLogTable;
